if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this._deferredObserver = null;
      }

      hide() {
        super.hide();
        if (this._deferredObserver) {
          this._deferredObserver.disconnect();
          this._deferredObserver = null;
        }
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.loadActiveDeferredImages();
        this.observeDeferredImages();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      loadActiveDeferredImages() {
        const activeId = this.openedBy && this.openedBy.getAttribute('data-media-id');
        if (!activeId) return;
        const activeMedia = this.querySelector(`[data-media-id="${activeId}"]`);
        if (activeMedia) this._hydrateDeferredImagesIn(activeMedia);
      }

      observeDeferredImages() {
        if (this._deferredObserver) return;
        const wrappers = this.querySelectorAll('.product-media-modal__media-wrapper');
        if (!wrappers.length) return;
        if (typeof IntersectionObserver === 'undefined') {
          wrappers.forEach((w) => this._hydrateDeferredImagesIn(w));
          return;
        }
        const root = this.querySelector('[role="document"]') || null;
        this._deferredObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              this._hydrateDeferredImagesIn(entry.target);
              this._deferredObserver.unobserve(entry.target);
            });
          },
          {
            root: root,
            rootMargin: '400px 0px',
            threshold: 0.01,
          }
        );
        wrappers.forEach((w) => this._deferredObserver.observe(w));
      }

      _hydrateDeferredImagesIn(container) {
        const imgs = container.querySelectorAll('img[data-src], img[data-srcset]');
        imgs.forEach((img) => {
          if (img.dataset.srcset) {
            img.srcset = img.dataset.srcset;
            img.removeAttribute('data-srcset');
          }
          if (img.dataset.src) {
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
          }
        });
      }
    }
  );
}
